import ButtonComponent from '../../Basic/Button/Button.mjs';
import { StyledList } from '../../Basic/Lists/HorizontalList/Horizontal.styles.mjs';
import HorizontalList from '../../Basic/Lists/HorizontalList/HorizontalList.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledCurrentWeather } from '../CurrentWeather/CurrentWeather.styles.mjs';
import Search from '../Search/Search.mjs';
import styled from 'styled-components';

const StyledButton = styled(ButtonComponent) `
  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 14px 16px 11px 12px;

    svg {
      position: relative;
      right: -3px;
    }
  }
`;
const StyledSearch = styled(Search) `
  width: 100%;

  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    display: none;
  }
`;
const StyledFlexContainer = styled(FlexContainer) `
  box-sizing: border-box;
`;
const StyledNavigation = styled.nav `
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: ${props => props.theme.zIndex.modal};
  box-shadow: 0px -1px 10px 0px ${props => props.theme.colors.black}26;

  ${StyledCurrentWeather} {
    margin: 0 14px 0 0;

    @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
      display: none;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
      margin: 0 30px 0 0;
    }
  }

  ${StyledList} {
    margin: 0 auto;
  }
`;
const StyledHorizontalList = styled(HorizontalList) `
  @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
    display: none;
  }
`;
const StyledTopNavigationLogoAnchor = styled.a `
  margin: 0 32px;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    margin: 0 0 0 40px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    margin: 0 0 0 32px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    margin: 0 0 0 40px;
  }
`;

export { StyledButton, StyledFlexContainer, StyledHorizontalList, StyledNavigation, StyledSearch, StyledTopNavigationLogoAnchor };
//# sourceMappingURL=TopNavigation.styles.mjs.map
